import * as Yup from "yup";

export const LoginValidationSchema = Yup.object().shape({
  country_code: Yup.string().required("Country code is required"),
  mobile: Yup.string()
    .required("mobile number is required")
    .max(10, "enter valid mobile number"),
});

export const SignupValidationSchema = Yup.object().shape({
  country_code: Yup.string().required("Country code is required"),
  mobile: Yup.string()
    .required("mobile number is required")
    .max(10, "enter valid mobile number"),
  referral_code: Yup.string().optional(),
});

export const ProfilevalidationSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("First Name is required")
    .matches(/^[A-Za-z ]*$/, "Please enter valid first name"),
  last_name: Yup.string()
    .required("Last Name is required")
    .matches(/^[A-Za-z ]*$/, "Please enter valid last name"),
  username: Yup.string()
    .required("Username is required")
    .matches(/^[a-zA-Z0-9][a-zA-Z0-9._]{2,14}$/, "Invalid username format"),
  email: Yup.string()
    .email("Invalid email address")
    .matches(/^\S+@\S+\.\S+$/, "Email cannot contain spaces")
    .matches(
      /^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email format"
    )
    .required("Email is required"),
  // address: Yup.string().required("Address is required"),
  // country: Yup.string().required("Country is required"),
  // city: Yup.string().required("City is required"),
  // state: Yup.string().required("State is required"),
  // zip_code: Yup.string()
  //   .required("Zip code is required")
  //   .matches(/^[0-9]+$/, "enter valid zip code"),
});

export const MultiRoundFantasyvalidationSchema = Yup.object().shape({
  name: Yup.string().required("Fantasy Name is required"),
  entry_fees: Yup.number()
    .typeError("Entry Coins must be a number")
    .required("Entry Coins is required"),
  start_date: Yup.date().required("Start Date is required"),
  // start_date_time: Yup.string().required("Starting Time is required"),
  league_size: Yup.number()
    .required("Number of Players is required")
    .typeError("Entry Coins must be a number")
    .min(6, "Number of Players must be at least 6"),
  bulls: Yup.number()
    .typeError("Bullish Assets must be a valid number")
    .required("Bullish Assets is required")
    .integer("Bullish Assets must be an integer")
    .min(0, "Bullish Assets cannot be negative"),
  bears: Yup.number()
    .typeError("Bearish Assets must be a valid number")
    .required("Bearish Assets is required")
    .integer("Bearish Assets must be an integer")
    .min(0, "Bearish Assets cannot be negative"),
  bench_stock_qty: Yup.number()
    .typeError("Bench Stock must be a valid number")
    .integer("Bench Stock must be an integer")
    .min(0, "Bench Stock cannot be negative"),
  // contest_prize_breakup_id: Yup.string().required('Prize Breakup ID is required'),
  // .test('even', 'Number of Players must be an even number', (value) => value % 2 === 0),
});

export const SingleRoundFantasyvalidationSchema = (Configdata) => {
  return Yup.object().shape({
    title: Yup.string().required("Fantasy Name is required"),

    // type: Yup.string().required('Contest Type is required'),
    // stock_distribution_type: Yup.string().required('Stocks Type is required'),
    //   bulls: Yup.number()
    // .required('Bullish Stocks Quantity is required')
    // .test('max-one-selected', 'You can only select one of Bullish or Bearish stocks', function (values) {
    //   const { bears } = this.parent;
    //   // Allow if values is 0 (no selection) or bears is 0
    //   return values === 0 || bears === 0 || (!values && !bears);
    // }),
    // bears: Yup.number()
    // .required('Bearish Stocks Quantity is required')
    // .test('max-one-selected', 'You can only select one of Bullish or Bearish stocks', function (values) {
    //   const { bulls } = this.parent;
    //   // Allow if values is 0 (no selection) or bulls is 0
    //   return values === 0 || bulls === 0 || (!values && !bulls);
    // }),
    entry_fees: Yup.number()
      .typeError("Entry Coins must be a number")
      .required("Entry Coins is required"),
    start_date: Yup.date().required("Start Date is required"),
    end_date: Yup.date()
      .required("End Date is required")
      .test(
        "date-difference",
        `The date difference should not exceed ${Configdata} days`,
        function (endDate) {
          const { start_date } = this.parent;
          if (start_date && endDate && Configdata) {
            const diffInDays = Math.ceil(
              (new Date(endDate).getTime() - new Date(start_date).getTime()) /
                (1000 * 3600 * 24)
            );
            if (diffInDays > Configdata) {
              return false;
            }
          }
          return true;
        }
      ),

    // contest_prize_breakup_id: Yup.string().required('Prize Breakup ID is required'),
    allowed_users: Yup.number()
      .required("Number of Players is required")
      .typeError("Entry Coins must be a number")
      .min(2, "Number of Players must be at least 2"),
    // .test('even', 'Number of Players must be an even number', (value) => value % 2 === 0),
    bulls: Yup.number()
      .typeError("Bullish Assets must be a valid number")
      .required("Bullish Assets is required")
      .integer("Bullish Assets must be an integer")
      .min(0, "Bullish Assets cannot be negative"),
    bears: Yup.number()
      .typeError("Bearish Assets must be a valid number")
      .required("Bearish Assets is required")
      .integer("Bearish Assets must be an integer")
      .min(0, "Bearish Assets cannot be negative"),
    bench_stock_qty: Yup.number()
      .typeError("Bench Stock must be a valid number")
      .integer("Bench Stock must be an integer")
      .min(0, "Bench Stock cannot be negative"),
  });
};
